import Shimmer from '@components/core/Shimmer/Shimmer';
import ShimmerWrapper from '@components/core/Shimmer/ShimmerWrapper';

const Preview = ({ width = '100%' , ...rest }) => {
    return (
        <ShimmerWrapper
            spacing={32}
            width={width}
            direction='column'
            align='flex-start'
            justify='flex-start'
            border
            padding='20px'
            {...rest}
        >
            <Shimmer width='100%' height={40} radius={6} />
            <Shimmer width='100%' height={20} radius={6} />
            <Shimmer width='100%' height={80} radius={6} />
            <Shimmer width='100%' height={80} radius={6} />
            <Shimmer width='100%' height={36} radius={6} />
        </ShimmerWrapper>
    );
};

const Editor = ({ width = '100%' , border = true , ...rest }) => {
    return (
        <ShimmerWrapper
            spacing={16}
            width={width}
            direction='column'
            align='flex-start'
            justify='flex-start'
            border={border}
            padding='20px'
            {...rest}
        >
            {Array.from({ length: 10 }).map((_, index) => (
                <Shimmer key={index} width='100%' height={36} radius={6} />
            ))}
        </ShimmerWrapper>
    );
};

const ApplicationFormBuilderSkeleton = () => {
    return (
        <ShimmerWrapper spacing={16} direction='row' align='flex-start'>
            <Editor width='70%' />
            <Preview width='30%' />
        </ShimmerWrapper>
    );
};

ApplicationFormBuilderSkeleton.Preview = Preview;
ApplicationFormBuilderSkeleton.Editor = Editor;

export default ApplicationFormBuilderSkeleton;
